<template>
  <section class="content">
    <modal title="Désactiver un maîtrise"
           v-on:close="doCloseAnyModals"
           v-if="deleteModal === true">
      <maitrises-delete slot="body"
                          v-on:close="doCloseAnyModals"
                          :maitrise="maitrise"></maitrises-delete>
    </modal>

    <modal title="Réactiver un maîtrise"
           v-on:close="doCloseAnyModals"
           v-if="reactivateModal === true">
      <maitrises-reactivate slot="body"
                        v-on:close="doCloseAnyModals"
                        :maitrise="maitrise"></maitrises-reactivate>
    </modal>

    <modal title="Modifier un maîtrise"
           v-on:close="doCloseAnyModals"
           v-if="updateModal === true">
      <maitrises-form slot="body"
                      v-on:close="doCloseAnyModals"
                      :maitrise-to-update="maitrise"></maitrises-form>
    </modal>

    <modal title="Créer un maîtrise"
           v-on:close="doCloseAnyModals"
           v-if="createModal === true">
      <maitrises-form slot="body"
                      v-on:close="doCloseAnyModals"></maitrises-form>
    </modal>

    <section class="content-toolbar">
      <div class="btn btn-primary"
           v-on:click="clickCreate()">Créer un maîtrise
      </div>
    </section>
    <maitrises-list v-on:delete="clickDelete"
                    v-on:edit="clickEdit"
                    v-on:reactivate="clickReactivate">
    </maitrises-list>
  </section>
</template>
<script>
  import MaitrisesList from './MaitrisesList'
  import MaitrisesForm from './MaitrisesForm'
  import MaitrisesDelete from './MaitrisesDelete'
  import MaitrisesReactivate from './MaitrisesReactivate'
  import Modal from '../commons/Modal'

  export default {
    components: {
      MaitrisesList,
      MaitrisesForm,
      MaitrisesDelete,
      MaitrisesReactivate,
      Modal,
    },
    data: function () {
      return {
        deleteModal: false,
        reactivateModal: false,
        updateModal: false,
        createModal: false,
        maitrise: null,
      }
    },
    methods: {
      clickDelete: function (maitrise) {
        this.maitrise = maitrise
        this.deleteModal = true
      },
      clickReactivate: function (maitrise) {
        this.maitrise = maitrise
        this.reactivateModal = true
      },
      clickEdit: function (maitrise) {
        this.maitrise = maitrise
        delete this.maitrise.password
        this.updateModal = true
      },
      clickCreate: function () {
        this.createModal = true
      },
      doCloseAnyModals: function () {
        this.reactivateModal = false
        this.deleteModal = false
        this.updateModal = false
        this.createModal = false
      },
    },
  }
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// Maitrises.vue?29c2f75b